// Demo mode's sign-in: no passwords or sign-up here, one link that signs the visitor in
// as the read-only demo viewer. A plain link (full page load), because the server answers
// with a redirect and sets the session cookie. With the sample project gate on
// (DEMO_ENTRY_SECRET on the server), the link leads to the website's form instead,
// which hands out the pass the entry needs.
import { useMeta } from "../../../api/meta";
import { PageHeader } from "../../../ui";

export function DemoEntry({ appName }: { appName: string }) {
  const { demoFormUrl } = useMeta();
  return (
    <div className="stack">
      <PageHeader title={`Try ${appName}`} documentTitle="Explore the demo" lead="Look around a sample project. You can't change anything, and you don't need an account." />
      <p>
        <a className="btn btn--primary btn--block" href={demoFormUrl ?? "/api/demo/enter"}>
          Explore the demo
        </a>
      </p>
    </div>
  );
}
